"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schedulePendingJobResponseSchema = exports.schedulePendingJobRequestSchema = exports.pendingJobPipelineBulkActionResponseSchema = exports.pendingJobPipelineBulkActionRequestSchema = exports.createPendingJobPipelineNoteRequestSchema = exports.transitionPendingJobPipelineRequestSchema = exports.updatePendingJobPipelineMetadataRequestSchema = exports.pendingJobPipelineFormOptionsResponseSchema = exports.pendingJobPipelineDetailResponseSchema = exports.pendingJobPipelineListResponseSchema = exports.pendingJobPipelineStageCountSchema = exports.pendingJobPipelineListQuerySchema = exports.pendingJobPipelineDetailSchema = exports.pendingJobPipelineActivitySchema = exports.pendingJobPipelineNoteSchema = exports.pendingJobPipelineItemSchema = exports.pendingJobPipelineLineageSchema = exports.pendingJobPipelineLocationSchema = exports.pendingJobPipelineOwnerSchema = exports.pendingJobPipelineFollowUpFilterSchema = exports.pendingJobPipelineReasonCodeSchema = exports.pendingJobPipelineSourceTypeSchema = exports.pendingJobPipelineStageSchema = exports.PENDING_JOB_PIPELINE_CONTRACT_VERSION = void 0;
const zod_1 = require("zod");
const job_1 = require("./job");
const pagination_1 = require("./pagination");
exports.PENDING_JOB_PIPELINE_CONTRACT_VERSION = 1;
exports.pendingJobPipelineStageSchema = zod_1.z.enum([
    "NEW_REQUEST",
    "ESTIMATE_NEEDED",
    "AWAITING_CUSTOMER",
    "APPROVED_UNSCHEDULED",
    "ON_HOLD",
    "READY_TO_SCHEDULE",
]);
exports.pendingJobPipelineSourceTypeSchema = zod_1.z.enum([
    "LEAD",
    "ESTIMATE",
    "JOB",
]);
exports.pendingJobPipelineReasonCodeSchema = zod_1.z.enum([
    "CUSTOMER_RESPONSE_PENDING",
    "ESTIMATE_REQUIRED",
    "APPROVED_AWAITING_SCHEDULE",
    "CUSTOMER_REQUEST",
    "WAITING_FOR_PARTS",
    "CAPACITY_CONSTRAINT",
    "INTERNAL_REVIEW",
    "SCOPE_CHANGED",
    "OTHER",
]);
exports.pendingJobPipelineFollowUpFilterSchema = zod_1.z.enum([
    "OVERDUE",
    "DUE_TODAY",
    "UPCOMING",
    "NONE",
]);
exports.pendingJobPipelineOwnerSchema = zod_1.z.object({
    membershipId: zod_1.z.string().uuid(),
    displayName: zod_1.z.string().trim().min(1).max(160).nullable(),
    email: zod_1.z.string().email().nullable(),
});
exports.pendingJobPipelineLocationSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string().trim().min(1).max(160),
    timezone: zod_1.z.string().trim().min(1).max(64),
});
exports.pendingJobPipelineLineageSchema = zod_1.z.object({
    leadId: zod_1.z.string().uuid().nullable(),
    estimateId: zod_1.z.string().uuid().nullable(),
    jobId: zod_1.z.string().uuid().nullable(),
});
exports.pendingJobPipelineItemSchema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.PENDING_JOB_PIPELINE_CONTRACT_VERSION),
    id: zod_1.z.string().uuid(),
    stage: exports.pendingJobPipelineStageSchema,
    sourceType: exports.pendingJobPipelineSourceTypeSchema,
    sourceId: zod_1.z.string().uuid(),
    canonicalStatus: zod_1.z.string().trim().min(1).max(80),
    lineage: exports.pendingJobPipelineLineageSchema,
    title: zod_1.z.string().trim().min(1).max(240),
    customer: zod_1.z.object({
        id: zod_1.z.string().uuid().nullable(),
        displayName: zod_1.z.string().trim().min(1).max(200),
    }),
    operationalLocation: exports.pendingJobPipelineLocationSchema,
    owner: exports.pendingJobPipelineOwnerSchema.nullable(),
    priority: job_1.jobPrioritySchema,
    followUpAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    followUpOverdue: zod_1.z.boolean(),
    holdReasonCode: exports.pendingJobPipelineReasonCodeSchema.nullable(),
    enteredStageAt: zod_1.z.string().datetime({ offset: true }),
    ageDays: zod_1.z.number().int().nonnegative(),
    availableTransitions: zod_1.z.array(exports.pendingJobPipelineStageSchema),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
});
exports.pendingJobPipelineNoteSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    body: zod_1.z.string().trim().min(1).max(5_000),
    author: zod_1.z.object({
        membershipId: zod_1.z.string().uuid().nullable(),
        name: zod_1.z.string().trim().min(1).max(160).nullable(),
    }),
    createdAt: zod_1.z.string().datetime({ offset: true }),
});
exports.pendingJobPipelineActivitySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: zod_1.z.enum([
        "CREATED",
        "METADATA_UPDATED",
        "STAGE_CHANGED",
        "NOTE_ADDED",
        "REMINDER_SCHEDULED",
        "REMINDER_DELIVERED",
        "SCHEDULED",
    ]),
    title: zod_1.z.string().trim().min(1).max(240),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    actor: zod_1.z.object({
        membershipId: zod_1.z.string().uuid().nullable(),
        name: zod_1.z.string().trim().min(1).max(160).nullable(),
    }),
    occurredAt: zod_1.z.string().datetime({ offset: true }),
});
exports.pendingJobPipelineDetailSchema = exports.pendingJobPipelineItemSchema.extend({
    notes: zod_1.z.array(exports.pendingJobPipelineNoteSchema),
    activities: zod_1.z.array(exports.pendingJobPipelineActivitySchema),
});
const queryBooleanSchema = zod_1.z.preprocess((value) => {
    if (value === "true")
        return true;
    if (value === "false")
        return false;
    return value;
}, zod_1.z.boolean().optional());
exports.pendingJobPipelineListQuerySchema = pagination_1.paginationQuerySchema.extend({
    search: zod_1.z.string().trim().max(160).optional(),
    stage: exports.pendingJobPipelineStageSchema.optional(),
    sourceType: exports.pendingJobPipelineSourceTypeSchema.optional(),
    ownerMembershipId: zod_1.z.string().uuid().optional(),
    unassigned: queryBooleanSchema,
    priority: job_1.jobPrioritySchema.optional(),
    followUp: exports.pendingJobPipelineFollowUpFilterSchema.optional(),
});
exports.pendingJobPipelineStageCountSchema = zod_1.z.object({
    stage: exports.pendingJobPipelineStageSchema,
    count: zod_1.z.number().int().nonnegative(),
});
exports.pendingJobPipelineListResponseSchema = zod_1.z.object({
    contractVersion: zod_1.z.literal(exports.PENDING_JOB_PIPELINE_CONTRACT_VERSION),
    items: zod_1.z.array(exports.pendingJobPipelineItemSchema),
    stageCounts: zod_1.z.array(exports.pendingJobPipelineStageCountSchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema,
});
exports.pendingJobPipelineDetailResponseSchema = zod_1.z.object({
    item: exports.pendingJobPipelineDetailSchema,
});
exports.pendingJobPipelineFormOptionsResponseSchema = zod_1.z.object({
    owners: zod_1.z.array(exports.pendingJobPipelineOwnerSchema),
});
exports.updatePendingJobPipelineMetadataRequestSchema = zod_1.z
    .object({
    expectedUpdatedAt: zod_1.z.string().datetime({ offset: true }),
    ownerMembershipId: zod_1.z.string().uuid().nullable().optional(),
    priority: job_1.jobPrioritySchema.optional(),
    followUpAt: zod_1.z.string().datetime({ offset: true }).nullable().optional(),
})
    .refine((value) => value.ownerMembershipId !== undefined ||
    value.priority !== undefined ||
    value.followUpAt !== undefined, { message: "At least one pipeline metadata change is required." });
exports.transitionPendingJobPipelineRequestSchema = zod_1.z
    .object({
    expectedUpdatedAt: zod_1.z.string().datetime({ offset: true }),
    toStage: exports.pendingJobPipelineStageSchema,
    reasonCode: exports.pendingJobPipelineReasonCodeSchema.nullable().default(null),
    note: zod_1.z.string().trim().min(1).max(5_000).optional(),
})
    .superRefine((value, context) => {
    if (value.toStage === "ON_HOLD" && !value.reasonCode) {
        context.addIssue({
            code: "custom",
            path: ["reasonCode"],
            message: "A stable reason code is required when work is put on hold.",
        });
    }
    if (value.toStage !== "ON_HOLD" && value.reasonCode) {
        context.addIssue({
            code: "custom",
            path: ["reasonCode"],
            message: "Reason code is only accepted for an on-hold transition.",
        });
    }
});
exports.createPendingJobPipelineNoteRequestSchema = zod_1.z.object({
    body: zod_1.z.string().trim().min(1).max(5_000),
});
const pendingJobPipelineBulkSelectionSchema = zod_1.z.object({
    itemIds: zod_1.z.array(zod_1.z.string().uuid()).min(1).max(50),
});
exports.pendingJobPipelineBulkActionRequestSchema = zod_1.z.discriminatedUnion("action", [
    pendingJobPipelineBulkSelectionSchema.extend({
        action: zod_1.z.literal("ASSIGN"),
        ownerMembershipId: zod_1.z.string().uuid().nullable(),
    }),
    pendingJobPipelineBulkSelectionSchema.extend({
        action: zod_1.z.literal("SET_PRIORITY"),
        priority: job_1.jobPrioritySchema,
    }),
    pendingJobPipelineBulkSelectionSchema.extend({
        action: zod_1.z.literal("SET_FOLLOW_UP"),
        followUpAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    }),
    pendingJobPipelineBulkSelectionSchema.extend({
        action: zod_1.z.literal("TRANSITION"),
        toStage: exports.pendingJobPipelineStageSchema,
        reasonCode: exports.pendingJobPipelineReasonCodeSchema.nullable().default(null),
    }),
]);
exports.pendingJobPipelineBulkActionResponseSchema = zod_1.z.object({
    results: zod_1.z.array(zod_1.z.object({
        itemId: zod_1.z.string().uuid(),
        outcome: zod_1.z.enum(["UPDATED", "UNCHANGED", "FAILED"]),
        errorCode: zod_1.z
            .enum([
            "NOT_FOUND",
            "INVALID_TRANSITION",
            "REFERENCE_NOT_FOUND",
            "CONCURRENT_CHANGE",
        ])
            .nullable(),
    })),
});
exports.schedulePendingJobRequestSchema = zod_1.z
    .object({
    idempotencyKey: zod_1.z.string().uuid(),
    expectedUpdatedAt: zod_1.z.string().datetime({ offset: true }),
    startAt: zod_1.z.string().datetime({ offset: true }),
    endAt: zod_1.z.string().datetime({ offset: true }),
    assignedMembershipId: zod_1.z.string().uuid().nullable(),
})
    .refine((value) => Date.parse(value.endAt) > Date.parse(value.startAt), {
    path: ["endAt"],
    message: "Schedule end must follow start.",
});
exports.schedulePendingJobResponseSchema = zod_1.z.object({
    item: exports.pendingJobPipelineDetailSchema,
    appointment: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        startAt: zod_1.z.string().datetime({ offset: true }),
        endAt: zod_1.z.string().datetime({ offset: true }),
        assignedMembershipId: zod_1.z.string().uuid().nullable(),
    }),
    idempotentReplay: zod_1.z.boolean(),
});
//# sourceMappingURL=pending-job-pipeline.js.map